const FIELD_LABELS = {
  email: "Email address",
  name: "Name",
  password: "Password",
  query: "Question",
  kb_id: "Knowledge base",
  file: "File",
};

function validationMessage(issue) {
  if (!issue || typeof issue !== "object") return "Please check the supplied information and try again.";
  const field = Array.isArray(issue.loc) ? issue.loc.at(-1) : null;
  const label = FIELD_LABELS[field];
  if (!label) return "Please check the supplied information and try again.";
  if (issue.type === "missing") return `${label} is required.`;
  if (field === "email") return "Enter a valid email address.";
  if (issue.type === "string_too_short") return `${label} is too short.`;
  if (issue.type === "string_too_long") return `${label} is too long.`;
  return `Please check ${label.toLowerCase()} and try again.`;
}

// FastAPI validation details can contain submitted values in `input` and `ctx`.
// Only derive messages from known fields and error types; never render the payload.
export function apiErrorMessage(body, fallback = "Request failed. Please try again.") {
  const detail = body?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (Array.isArray(detail) && detail.length) {
    return [...new Set(detail.map(validationMessage))].slice(0, 3).join(" ");
  }
  return fallback;
}
